import React, { PureComponent } from 'react';

import styled, { css } from 'styled-components';
import { Row, FlexView } from '@cuemath/comps';
import moreOptions from 'img/more-options.svg';
import COLORS from 'constants/colors';
import { ATTEMPT_LOCATION } from 'constants/node';

import SheetDetails from './sheet-details';
import OptionsView from './options-view';

const SheetItemWrapper = styled(Row)`
  padding: 0 12px 0 24px;
  flex-wrap: nowrap;
`;

const SheetDetailsContainer = styled(Row)`
  flex: 1;
  padding: 12px 6px;
  margin: 5px 0;
  margin-left: 8px;
  border-radius: 8px;
  flex-wrap: nowrap;
  align-self: center;
  background: ${({ colorManager, timedSheet }) =>
    timedSheet
      ? COLORS.BRASS
      : colorManager === ATTEMPT_LOCATION.ANY
      ? COLORS.LIGHT_PASTEL_PURPLE
      : colorManager === ATTEMPT_LOCATION.INCLASS
      ? COLORS.CAPRI
      : COLORS.SHINY_SHAMROCK};
  opacity: ${({ showBlur }) => (showBlur ? 0.5 : 1)};

  ${({ showBorder }) =>
    showBorder &&
    css`
      border-bottom: 2px solid ${COLORS.BORDER};
    `}
`;

const SheetActions = styled(Row)`
  flex-wrap: nowrap;
`;

const OptionsWrapper = styled.div`
  position: relative;
  cursor: pointer;
  background: ${({ colorManager, timedSheet }) =>
    timedSheet
      ? COLORS.BRASS
      : colorManager === ATTEMPT_LOCATION.ANY
      ? COLORS.LIGHT_PASTEL_PURPLE
      : colorManager === ATTEMPT_LOCATION.INCLASS
      ? COLORS.CAPRI
      : COLORS.SHINY_SHAMROCK};
`;

const OptionsImageWrapper = styled.div`
  width: 48px;
  height: 48px;
  background: ${({ colorManager, timedSheet }) =>
    timedSheet
      ? COLORS.BRASS
      : colorManager === ATTEMPT_LOCATION.ANY
      ? COLORS.LIGHT_PASTEL_PURPLE
      : colorManager === ATTEMPT_LOCATION.INCLASS
      ? COLORS.CAPRI
      : COLORS.SHINY_SHAMROCK};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  :hover {
    background-color: ${COLORS.SKY_XXLIGHT};
  }
`;

const OptionsImage = styled.img`
  opacity: 0.6;
  width: 28px;
  height: 28px;
`;

const TopDashBox = styled.div`
  width: 10px;
  height: 50%;
  border-left: 1px dashed ${COLORS.GRAY};
  border-bottom: 1px dashed ${COLORS.GRAY};
`;

const BottomDashBox = styled.div`
  width: 10px;
  height: 50%;
  border-left: 1px dashed ${COLORS.GRAY};
`;

class SheetItem extends PureComponent {
  render() {
    const {
      worksheet,
      isLastSheet,
      dependencyDataList,
      linkedDataList,
      nodeDataList,
      completionData,
      attempt_location: attemptLocation,
      node_type: nodeType,
      position,
      is_timed: timedSheet,
      is_live: liveSheet,
      is_optional: optionalSheet,
    } = this.props;

    return (
      <SheetItemWrapper>
        <FlexView>
          <TopDashBox />
          {!isLastSheet && <BottomDashBox />}
        </FlexView>
        <SheetDetailsContainer
          justifyContent="space-between"
          showBorder={!isLastSheet}
          colorManager={attemptLocation}
          timedSheet={timedSheet}
        >
          <SheetDetails
            workSheet={worksheet}
            attemptLocation={attemptLocation}
            nodeDataList={nodeDataList}
            dependencyDataList={dependencyDataList}
            nodeType={nodeType}
            position={position}
            timedSheet={timedSheet}
            liveSheet={liveSheet}
            optionalSheet={optionalSheet}
            linkedDataList={linkedDataList}
            completionData={completionData}
          />
        </SheetDetailsContainer>
      </SheetItemWrapper>
    );
  }
}

export default SheetItem;
